<template>
    <div :class="containerClass" :data-theme="colorScheme" @click="onDocumentClick($event)">
        <div class="layout-content-wrapper">
            <AppTopBar :topbarNotificationMenuActive="topbarNotificationMenuActive" :topbarUserMenuActive="topbarUserMenuActive"
                       :layoutMode="layoutMode" :menu="menu" :menuActive="menuActive" :staticMenuMobileActive='staticMenuMobileActive'
                       @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"
                       @menu-button-click="onMenuButtonClick" @search-click="toggleSearch" @topbar-notification="onTopbarNotificationMenuButtonClick"
                       @topbar-user-menu="onTopbarUserMenuButtonClick" @right-menu-click="onRightMenuButtonClick" @right-menubutton-click="onRightMenuButtonClick"></AppTopBar>

            <div class="layout-content">

                <div class="layout-breadcrumb viewname" style="text-transform: uppercase">
                    <template v-if="$route.meta.breadcrumb">
                        <span>{{$route.meta.breadcrumb[0].label}}</span>
                    </template>
                </div>

                <Button v-if="$config.isChatbotEnabled(chatbot) && !$functions.isMobile() && !isChatBotOpen" class="p-button-rounded chatbot chatbot-open" 
                          @click="toggleChatBot(false)" :aria-label="$t('menu.ai-virtual-assistant')">
                  <img src="assets/irinox/icons/frosty.svg" :alt="$t('menu.ai-virtual-assistant')" width="50"/>
                </Button>
                <div v-if="isChatBotOpen && $config.isChatbotEnabled(chatbot) && !$functions.isMobile()" class="chatbot-op">
                  <div class="chatbot-op-header p-d-flex p-jc-between p-ai-center">
                    <div class="p-d-flex p-ai-center p-pr-1 p-pl-1">
                      <img src="assets/irinox/icons/frosty.svg" :alt="$t('menu.ai-virtual-assistant')" width="35"/>
                      <div class="p-ml-2">{{ $t('bot.title') }}</div>
                    </div>
                    <div class="p-d-flex p-ai-center p-pr-1 p-pl-1">
                      <img src="assets/irinox/icons/bot_minimize.svg" @click="toggleChatBot(false)" v-tooltip.top="$t('bot.minimize')" :alt="$t('bot.minimize')" width="30" class="p-mr-2"/>
                      <!-- <i class="pi pi-window-minimize p-mr-2" @click="toggleChatBot(false)" v-tooltip.top="$t('bot.minimize')"/> -->
                      <i class="pi pi-times" @click="toggleChatBot(true)" v-tooltip.top="$t('bot.close')"/>
                    </div>
                  </div>
                  <div class="chatbot-op-content"><ChatBot></ChatBot></div>
                </div>

                <router-view/>
            </div>
            <!-- <AppFooter/> -->
            <Loader />
            <ScrollTop />

            <div v-if="isDev" class="mock-role" style="right: 460px; width: 110px; color: blue">
              <div>Active role: <br/> <b>{{ role }}</b></div>
            </div>
            <div v-if="isDev" class="mock-role" style="right: 380px;">
              <div @click="mockRole('SUPERFACTORY')">SUPERFACTORY</div>
              <div @click="mockRole('FACTORY')">FACTORY</div>
              <div @click="mockRole('SUBSIDIARY')">SUBSIDIARY</div>
            </div>
            <div v-if="isDev" class="mock-role" style="right: 320px;">
              <div @click="mockRole('INTERNAL')">INTERNAL</div>
              <div @click="mockRole('INTERNAL_DOC')">DOC</div>
              <div @click="mockRole('INTERNAL_SUB')">INT SUB</div>
            </div>
            <div v-if="isDev" class="mock-role" style="right: 270px;">
              <div @click="mockRole('SERVICE')">SERVICE</div>
              <div @click="mockRole('SERVICE_SALES')">SALES</div>
              <div @click="mockRole('USER')">USER</div>
            </div>

            <!-- <Dialog v-model:visible="legalDialog" class="irinox-dialog-legal" :modal="true" :dismissableMask="true"
                  :style="{width: '590px'}" :draggable="false" >
              
              <template #header>
                <img src="assets/irinox/logo/header-big.svg" width="200" />
              </template>

              <div class="irinox-dialog-legal-content">
                <p>
                  IRINOX S.p.A.<br>
                  Via Caduti nei Lager, 1<br>
                  31015 Conegliano (TV) - Italy
                </p>
                <p>
                  © 2021 IRINOX S.p.A
                </p>
                <p>
                  P.IVA 02152370264
                </p>
                <div class="p-fluid p-grid p-pt-4">
                    <div class="p-col-6">
                        <a :href="docsMapping[$i18n.locale].privacy" target="_new">
                          FreshCloud Privacy policy
                        </a>
                    </div>
                    <div class="p-col-6 p-text-right">
                        <a :href="docsMapping[$i18n.locale].tos" target="_new">
                          FreshCloud Terms
                        </a>
                    </div>
                </div>
              </div>

              <template #footer>
              </template>
            </Dialog> -->

            <MandatoryChecks/>

            <!-- <News /> -->
        </div>
    </div>
</template>

<script>
import AccountService from './service/AccountService';
import AiService from './service/AiService';
import EventBus from './event-bus';
import AppTopBar from "./AppTopbar";
import Loader from './components/Loader.vue';
import { mapGetters } from 'vuex';
// import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import docsMapping from "../public/json/docs_mapping.json";
import ChatBot from './components/misc/ChatBot.vue';
// import News from './components/misc/News.vue';
import MandatoryChecks from './components/account/MandatoryChecks.vue';

export default {
    data() {
        return {
            menuActive: false,
            layoutMode: "overlay",
            colorScheme: "light",
            menuTheme: "layout-sidebar-irinox",
            overlayMenuActive: false,
            staticMenuDesktopInactive: false,
            staticMenuMobileActive: false,
            menuClick: false,
            searchActive: false,
            searchClick: false,
            userMenuClick: false,
            topbarUserMenuActive: false,
            notificationMenuClick: false,
            topbarNotificationMenuActive: false,
            rightMenuClick: false,
            rightMenuActive: false,
            configActive: false,
            configClick: false,
            menu: [],
            legalDialog: false,
            ws: {
              socket: null,
              stompClient: null,
              url: null,
              data: []
            },
            isDev: process.env.NODE_ENV === 'development',
            notificationCounterInterval: null,
            docsMapping: docsMapping,
            isChatBotOpen: false,
        };
    },
    computed: {
        containerClass() {
            return [
                "layout-wrapper",
                {
                    "layout-overlay": this.layoutMode === "overlay",
                    "layout-static": this.layoutMode === "static",
                    "layout-slim": this.layoutMode === "slim",
                    'layout-horizontal': this.layoutMode === 'horizontal',
                    "layout-sidebar-dim": this.colorScheme === "dim",
                    "layout-sidebar-dark": this.colorScheme === "dark",
                    "layout-overlay-active": this.overlayMenuActive,
                    "layout-mobile-active": this.staticMenuMobileActive,
                    "layout-static-inactive": this.staticMenuDesktopInactive && this.layoutMode === "static",
                    "p-input-filled": this.$primevue.config.inputStyle === "filled",
                    "p-ripple-disabled": !this.$primevue.config.ripple,
                },
                this.colorScheme === "light" ? this.menuTheme : "",
            ];
        },
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          refreshtoken: 'userdata/refreshtoken',
          websitetoken: 'userdata/websitetoken',
          websiterefreshtoken: 'userdata/websiterefreshtoken',
          email: 'userdata/email',
          role: 'userdata/role',
          cycleLibrary: 'userdata/cycleLibrary',
          energyPanel: 'userdata/energyPanel',
          chatbot: 'userdata/chatbot',
          digitalWarehouse: 'userdata/digitalWarehouse',
        }),
        idpUserId: function() {
          return this.$store.state.userdata.idpUserId;
        },
    },
    components: {
        AppTopBar,
        Loader,
        ChatBot,
        MandatoryChecks,
        // News,
    },
    created() {
      this.$functions.setFormatNumberFunction(this.$n);
      this.accountService = new AccountService();
      this.aiService = new AiService();
        // if(process.env.NODE_ENV === 'development') {
          // console.log(JSON.stringify(process.env));
        // }
        this.updateLocalization();
        this.$store.dispatch('userdata/init');
        this.checkUserdata();
        window.onbeforeunload = function() {
          if(this.notificationCounterInterval) {
            console.log("Clear notification interval");
            clearInterval(this.notificationCounterInterval);
          }
          this.disconnect();
          if(process.env.NODE_ENV === 'development' && this.ws.data.length>0 && this.$config.saveWebsocket) {  
            var hiddenElement = document.createElement('a');  
            hiddenElement.href = 'data:text/plain;charset=utf-8,' + encodeURI(this.ws.data);  
            hiddenElement.target = '_blank';  
            hiddenElement.download = 'IrinoxSocket_'+new Date().getTime()+'.txt';  
            hiddenElement.click(); 
          } 
        }.bind(this);
    },
    mounted() {
      if(this.idpUserId && (this.role==="USER" || this.role.includes("SERVICE"))) {
        this.connect();
      }
      if(this.idpUserId && this.role==="USER") {
        this.refreshNotificationCounter();
        this.notificationCounterInterval = setInterval(function() {
          this.refreshNotificationCounter();
        }.bind(this),30000);
      }
    },
    unmounted() {
      if(this.notificationCounterInterval) {
        console.log("Clear notification interval");
        clearInterval(this.notificationCounterInterval);
      }
      this.disconnect();
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
        email: 'checkUserdata',
        idpUserId: 'checkUserdata',
        '$i18n.locale': 'updateLocalization'
    },
    methods: {
        refreshNotificationCounter() {
          if(this.$config.maintenanceEnabled()) {
            this.accountService.getNotificationsCounterV2(this.personaltoken)
              .then(counter => {
                this.menu.find(m => m.id === "notification").items[0].badge = counter;
              })
              .catch(error => {
                console.error("EXCEPTION "+error);
              });
          } else {
            this.accountService.getNotificationsCounter(this.personaltoken)
              .then(counter => {
                this.menu.find(m => m.id === "notification").items[0].badge = counter;
              })
              .catch(error => {
                console.error("EXCEPTION "+error);
              });
          }
        },
        mockRole(role) {
          if(this.isDev) {
            this.$store.commit('userdata/role', role);
            this.updateLocalization();
          }
        },
        connect() {
          console.log('CONNECT');
          // this.ws.socket = new SockJS(this.$config.env().socket + '/secured/room');
          this.ws.socket = new this.$window.WebSocket(this.$config.env().socket + '/secured/room');
          this.ws.stompClient = Stomp.over(this.ws.socket, {
            debug: this.$config.verbose
          });
          this.ws.stompClient.connect({}, function (frame) {
            console.debug("FRAME: "+frame);
            // this.ws.url = this.ws.stompClient.ws._transport.url;
            this.ws.stompClient.subscribe('/secured/user/topic/' + this.idpUserId + '/', function (msgOut) {
              console.debug("Socket message: " + msgOut);
              let msg = JSON.parse(msgOut.body);
              if(process.env.NODE_ENV === 'development') {  
                this.ws.data += '\n'+JSON.stringify(msg);
              }
              this.$store.dispatch('appliances/websocket', msg);
            }.bind(this));
          }.bind(this));
        },
        disconnect() {
          if (this.ws.stompClient && this.ws.stompClient.connected) {
            console.log('DISCONNECT');
            try {
              this.ws.stompClient.disconnect();
            } catch(err) {
              console.warn(err);
            }
          }
        },
        updateLocalization: async function() {
          this.menu = [];

          if(this.role==='USER') {
            this.menu.push({
                    label: "", icon: "icon-menu dashboard", to: "/", style: { backgroundImage: "url('assets/irinox/icons/devices.svg')" },
                    items: [
                        {label: this.$t("menu.dashboard"), icon: "icon-menu dashboard", to: "/", style: { backgroundImage: "url('assets/irinox/icons/devices.svg')" }},
                    ]
                });
            // if(this.cycleLibrary) { //TODO
              // this.menu.push({
              //         label: "", icon: "icon-menu digital-warehouse", style: { backgroundImage: "url('assets/irinox/icons/warehouse.svg')" },
              //         items: [
              //             {label: this.$t("menu.digital_warehouse"), icon: "icon-menu digital-warehouse", to: "/digital-warehouse", style: { backgroundImage: "url('assets/irinox/icons/warehouse.svg')" }},
              //         ],
              //     });
            // }
            if(this.cycleLibrary) {
              this.menu.push({
                      label: "", icon: "icon-menu cycles", style: { backgroundImage: "url('assets/irinox/icons/cycles.svg')" },
                      items: [
                          {label: this.$t("menu.cycles"), icon: "icon-menu cycles", to: "/library", style: { backgroundImage: "url('assets/irinox/icons/cycles.svg')" }},
                      ],
                  });
            }
            // this.menu.push({
            //         label: "", icon: "icon-menu haccp", style: { backgroundImage: "url('assets/irinox/icons/haccp_new.svg')" },
            //         items: [
            //             {label: this.$t("menu.haccp"), icon: "icon-menu haccp", to: "/haccp", style: { backgroundImage: "url('assets/irinox/icons/haccp_new.svg')" }},
            //         ],
            //     });
            this.menu.push({
                    label: "", icon: "icon-menu analytics", style: { backgroundImage: "url('assets/irinox/icons/analytics_new.svg')" },
                    items: [
                        {label: this.$t("menu.analytics"), icon: "icon-menu analytics", to: "/analytics", style: { backgroundImage: "url('assets/irinox/icons/analytics_new.svg')" }},
                    ],
                });

            if(this.energyPanel) {
              this.menu.push({
                      label: "", icon: "icon-menu energy", style: { backgroundImage: "url('assets/irinox/icons/energy_white.svg')" },
                      items: [
                          {label: this.$t("menu.energy"), icon: "icon-menu energy", to: "/energy", style: { backgroundImage: "url('assets/irinox/icons/energy_white.svg')" }},
                      ],
                  });
            }
            this.menu.push({
                    id: "notification",
                    label: "", icon: "icon-menu notification", style: { backgroundImage: "url('assets/irinox/icons/notification.svg')" },
                    items: [
                        {label: this.$t("menu.notifications"), icon: "icon-menu notification", to: "/notifications", style: { backgroundImage: "url('assets/irinox/icons/notification.svg')" }, badge: 0},
                    ],
                });
            // if(!this.$functions.isDemoMode(this.email)) {
            //   this.menu.push({
            //           label: "", icon: "icon-menu tutorial", style: { backgroundImage: "url('assets/irinox/icons/tutorial.svg')" },
            //           items: [
            //               {label: this.$t("menu.tutorial"), icon: "icon-menu tutorial", url: "https://chefsguide.irinoxprofessional.com/", target: "_blank" , style: { backgroundImage: "url('assets/irinox/icons/tutorial.svg')" }},
            //           ],
            //       });
            // }
            // this.menu.push({
            //         label: "", icon: "icon-menu faq", style: { backgroundImage: "url('assets/irinox/icons/faq.svg')" },
            //         items: [
            //             {label: this.$t("menu.faq"), icon: "icon-menu faq", to: "/faq", style: { backgroundImage: "url('assets/irinox/icons/faq.svg')" }},
            //         ],
            //     });
          }

          if(this.role.includes('FACTORY') || this.role==='SUBSIDIARY' || this.role.includes('INTERNAL')) {
            this.menu.push({
                    label: "", icon: "icon-menu admin", to: "/factory", style: { backgroundImage: "url('assets/irinox/icons/admin.svg')" },
                    items: [
                        {label: this.$t("menu.admin"), icon: "icon-menu admin", to: "/factory", style: { backgroundImage: "url('assets/irinox/icons/admin.svg')" }},
                    ]
                });
          }
          if(this.role==='SUPERFACTORY') {
            this.menu.push({
                    label: "", icon: "icon-menu fota", style: { backgroundImage: "url('assets/irinox/icons/fota.svg')" },
                    items: [
                        {label: this.$t("menu.fota"), icon: "icon-menu fota", to: "/fota", style: { backgroundImage: "url('assets/irinox/icons/fota.svg')" }},
                    ],
                });
          }

          if(this.role.includes('SERVICE')) {
            this.menu.push({
                    label: "", icon: "icon-menu admin", to: "/service", style: { backgroundImage: "url('assets/irinox/icons/admin.svg')" },
                    items: [
                        {label: this.$t("menu.admin"), icon: "icon-menu admin", to: "/service", style: { backgroundImage: "url('assets/irinox/icons/admin.svg')" }},
                    ]
                });
            this.menu.push({
                    label: "", icon: "icon-menu analytics", style: { backgroundImage: "url('assets/irinox/icons/analytics_new.svg')" },
                    items: [
                        {label: this.$t("menu.analytics"), icon: "icon-menu analytics", to: "/analytics", style: { backgroundImage: "url('assets/irinox/icons/analytics_new.svg')" }},
                    ],
                });
          }
          
          if(this.role.includes('FACTORY') || this.role==='SUBSIDIARY' || this.role.includes('SERVICE') || this.role.includes('INTERNAL')) {
            this.menu.push({
              label: "", icon: "icon-menu report", style: { backgroundImage: "url('assets/irinox/icons/report.svg')" },
              items: [
                {label: this.$t("menu.report"), icon: "icon-menu report", to: "/report", style: { backgroundImage: "url('assets/irinox/icons/report.svg')" }},
              ],
            });
          }
          
          // if(this.role.includes('SERVICE')) {
          //   this.menu.push({
          //           label: "", icon: "icon-menu faq", style: { backgroundImage: "url('assets/irinox/icons/faq.svg')" },
          //           items: [
          //               {label: this.$t("menu.faq"), icon: "icon-menu faq", to: "/faq", style: { backgroundImage: "url('assets/irinox/icons/faq.svg')" }},
          //           ],
          //       });
          // }

          //This is for TEST
          // this.menu.push({
          //         label: "", icon: "icon-menu test", to: "/test" ,
          //         items: [
          //             {label: "TEST", icon: "icon-menu test", to: "/test"},
          //         ]
          //     });

          if(this.$config.afterSalesEnabled()) {
            this.menu.push({
                label: "", icon: "icon-menu after-sales", style: { backgroundImage: "url('assets/irinox/icons/afterSales_menu.svg')" },
                items: [
                  {label: this.$t("menu.after_sales"), icon: "icon-menu after-sales", to: "/after-sales", style: { backgroundImage: "url('assets/irinox/icons/afterSales_menu.svg')" }},
                ],
              });
              if(this.role!=='USER') {
                this.menu.push({
                  label: "", icon: "icon-menu legal", style: { backgroundImage: "url('assets/irinox/icons/sales_conditions.svg')" },
                  items: [
                    { label: this.$t("menu.sales_conditions"), icon: "icon-menu legal", style: { backgroundImage: "url('assets/irinox/icons/sales_conditions.svg')" }, command: () => { this.downloadSalesConditions(); } },
                  ],
                });
              }
          }

          if(this.$config.isChatbotEnabled(this.chatbot) && this.$functions.isMobile()) {
            this.menu.push({
                    label: "", icon: "icon-menu ai-virtual-assistant", style: { backgroundImage: "url('assets/irinox/icons/frosty.svg')" },
                    items: [
                        {label: this.$t("menu.ai-virtual-assistant"), icon: "icon-menu ai-virtual-assistant", to: "/ai-virtual-assistant", style: { backgroundImage: "url('assets/irinox/icons/frosty.svg')", backgroundSize: "35px"}},
                    ],
                });
          }

          if(this.role!='USER' && !this.role.includes('SERVICE')) {
            this.menu.push({
              label: "", icon: "icon-menu roi-calculator", style: { backgroundImage: "url('assets/irinox/icons/roi_calculator.svg')" },
              items: [
                { label: this.$t("menu.roi_calculator"), icon: "icon-menu roi-calculator", style: { backgroundImage: "url('assets/irinox/icons/roi_calculator.svg')" }, command: () => { this.roiCalculator(); } },
              ],
            });
          }

          //Separator
          this.menu.push({ 
                  separator: true,
                  bottom: true
                });

          if(this.role==='USER') {
                this.menu.push({
                    label: "", icon: "icon-menu admin", style: { backgroundImage: "url('assets/irinox/icons/admin.svg')" },
                    items: [
                        {label: this.$t("menu.admin"), icon: "icon-menu admin", to: "/admin", style: { backgroundImage: "url('assets/irinox/icons/admin.svg')" }},
                    ],
                    bottom: true
                });
          }
          if(this.role==='USER' || this.role.includes('SERVICE')) {
                this.menu.push({
                    label: "", icon: "icon-menu support", style: { backgroundImage: "url('assets/irinox/icons/support.svg')" },
                    items: [
                        {label: this.$t("menu.support"), icon: "icon-menu support", to: "/support", style: { backgroundImage: "url('assets/irinox/icons/support.svg')" }},
                    ],
                    bottom: true
                });
          }

          this.menu.push({
              label: "", icon: "icon-menu accessibility", style: { backgroundImage: "url('assets/irinox/icons/accessibility_small.svg')" },
              items: [
                  {label: this.$t("menu.accessibility"), icon: "icon-menu accessibility", to: "/accessibility", style: { backgroundImage: "url('assets/irinox/icons/accessibility_small.svg')" }},
              ],
              bottom: true
          });

          //Legal
          // this.menu.push({
          //           label: "", icon: "icon-menu legal", style: { backgroundImage: "url('assets/irinox/icons/legal.svg')" },
          //           items: [
          //               {label: this.$t("menu.legal"), icon: "icon-menu legal", style: { backgroundImage: "url('assets/irinox/icons/legal.svg')" }, command: () => this.legalDialog = true },
          //           ],
          //           bottom: true
          //       });
        },
        checkUserdata() {
            if (this.idpUserId == null) {
                console.log('You are not logged in!');
                // console.log("Route "+JSON.stringify(this.$route));
                // console.log("Location "+JSON.stringify(location));
                if(!location.href.includes("#/changepassword?")) {
                  this.$router.push({ name: 'login' });
                }
            }
        },
        onDocumentClick() {
            if (!this.searchClick && this.searchActive) {
                this.onSearchHide();
            }

            if (!this.userMenuClick) {
                this.topbarUserMenuActive = false;
            }

            if (!this.notificationMenuClick) {
                this.topbarNotificationMenuActive = false;
            }

            if (!this.rightMenuClick) {
                this.rightMenuActive = false;
            }

            if (!this.menuClick) {
                if (this.isSlim() || this.isHorizontal()) {
					EventBus.emit('reset-active-index');
					this.menuActive = false;
                }

                if (this.overlayMenuActive || this.staticMenuMobileActive) {
                    this.hideOverlayMenu();
                }

                this.unblockBodyScroll();
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            this.searchClick = false;
            this.configClick = false;
            this.userMenuClick = false;
            this.rightMenuClick = false;
            this.notificationMenuClick = false;
            this.menuClick = false;
        },
        onMenuClick() {
            this.menuClick = true;
        },
        onMenuButtonClick(event) {
            this.menuClick = true;
            this.topbarUserMenuActive = false;
            this.topbarNotificationMenuActive = false;
            this.rightMenuActive = false;

            if (this.isOverlay()) {
                this.overlayMenuActive = !this.overlayMenuActive;
            }

            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
                if (this.staticMenuMobileActive) {
                    this.blockBodyScroll();
                } else {
                    this.unblockBodyScroll();
                }
            }

            event.preventDefault();
        },
        onMenuItemClick(event) {
			if (!event.item.items) {
				EventBus.emit('reset-active-index');
				this.hideOverlayMenu();
			}
			if (!event.item.items && (this.isSlim() || this.isHorizontal())) {
                this.menuActive = false;
            }
        },
		onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        onTopbarUserMenuButtonClick(event) {
            this.userMenuClick = true;
            this.topbarUserMenuActive = !this.topbarUserMenuActive;

            this.hideOverlayMenu();

            event.preventDefault();
        },
        onTopbarNotificationMenuButtonClick(event) {
            this.notificationMenuClick = true;
            this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

            this.hideOverlayMenu();

            event.preventDefault();
        },
        toggleSearch() {
            this.searchActive = !this.searchActive;
            this.searchClick = true;
        },
        onSearchClick() {
            this.searchClick = true;
        },
        onSearchHide() {
            this.searchActive = false;
            this.searchClick = false;
        },
        onRightMenuClick() {
			this.rightMenuClick = true;
		},
        onRightMenuButtonClick(event) {
			this.rightMenuClick = true;
			this.rightMenuActive = !this.rightMenuActive;
			this.hideOverlayMenu();
			event.preventDefault();
		},
        onConfigClick() {
            this.configClick = true;
        },
        onConfigButtonClick() {
            this.configActive = !this.configActive;
            this.configClick = true;
        },
        hideOverlayMenu() {
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
            this.unblockBodyScroll();
        },
        blockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        },
        unblockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                    'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        },
        isSlim() {
            return this.layoutMode === "slim";
        },
        isHorizontal() {
            return this.layoutMode === "horizontal";
        },
        isOverlay() {
            return this.layoutMode === "overlay";
        },
        isDesktop() {
            return window.innerWidth > 1091;
        },
        toggleChatBot(deleteHistory) {
          if(deleteHistory) {
            // this.aiService.botDeleteChatSessionHistory(this.personaltoken);
            this.$store.commit('ai/clearChatBotMessages');
          }
          this.isChatBotOpen = !this.isChatBotOpen;
          // this.$refs.bot_op.toggle(event);
        },
        downloadSalesConditions() {
          let url = this.docsMapping[this.$i18n.locale].sales;
          this.$window.open(url, '_blank');
        },
        roiCalculator() {
          // const roiUrl = 'https://www.irinoxprofessional.com/it_ww/irinox-hub/calcolatore-roi';
          // const roiUrl = 'https://lively-rock-0567c7603.6.azurestaticapps.net/';
          const roiUrl = 'https://roi.irinoxprofessional.com/';
          const targetOrigin = 'https://roi.irinoxprofessional.com';
          const roiWindow = this.$window.open(roiUrl, '_blank');

          if (!roiWindow) {
            return;
          }

          const authPayload = {
            type: 'AUTH_TOKEN',
            token: this.websitetoken,
            refresh: this.websiterefreshtoken,
          };

          const sendAuthMessage = () => {
            try {
              roiWindow.postMessage(authPayload, targetOrigin);
            } catch (err) {
              console.warn('Unable to send AUTH_TOKEN postMessage', err);
            }
          };

          // Send immediately and retry shortly after to cover slower page bootstraps.
          // sendAuthMessage();
          // setTimeout(sendAuthMessage, 600);
          setTimeout(sendAuthMessage, 1000);
        }
    },
};
</script>

<style lang="scss">
@import "App.scss";
@import "App_Carousel.scss";
@import "App_Responsive.scss";
@import "App_OverrideMenu.scss";
</style>
